import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Requires authenticated user with an active/trialing subscription
export default function MemberRoute({ children }) {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#111315] text-white flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#CBB26A] mb-4"></div>
          <p className="text-neutral-400">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const sub = user?.subscription;
  const ok = sub && (sub.status === 'active' || sub.status === 'trialing');
  if (!ok) {
    // Show a friendly gating page rather than a silent redirect
    return (
      <div className="min-h-screen bg-[#111315] text-white flex items-center justify-center px-6">
        <div className="max-w-md w-full bg-neutral-950/80 ring-1 ring-neutral-800 rounded-2xl p-8 text-center">
          <div className="text-2xl font-black mb-2">Plan Required</div>
          <p className="text-neutral-400 mb-6">A plan is required to use this feature.</p>
          <div className="flex items-center justify-center gap-3">
            <a href="/#tiers" className="px-5 py-3 rounded-lg bg-neutral-900 ring-1 ring-neutral-700 hover:ring-[#CBB26A] hover:text-[#CBB26A] transition font-bold">View Pricing</a>
            <a href="/checkout?plan=institutional&cycle=monthly" className="px-5 py-3 rounded-lg bg-gradient-to-r from-[#CBB26A] to-[#A8914D] text-black font-bold hover:from-[#D8C585] hover:to-[#BDA45E] transition">Get Started</a>
          </div>
        </div>
      </div>
    );
  }

  return children;
}
